require('./bootstrap');
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router, Route, Switch} from "react-router-dom";
import jwt_decode from 'jwt-decode'
import Echo from 'laravel-echo';
window.io = require('socket.io-client');
// History
import history from './actions/history';
// Components
import Signin from './components/auth/signin';
import Signup from './components/auth/signup';
import Recover from './components/auth/recover';
import Index from './components/dashboard/Dashboard';
import Viewer from './components/viewer/Viewer';
import CasoForm from './components/forms/CasoForm';
import ModelosForm from './components/forms/ModelosForm';
import NotFound from './components/errors/404'
import Casos from './components/casos/Casos';
import Settings from './components/settings/Settings';
// Admin components
import IndexAdmin from './components/admin/dashboard/Dashboard';
import Clients from './components/admin/clients/Clients';
import Client from './components/admin/clients/Client';
import newClient from './components/admin/clients/newClient';
// Containers
import RequireAuthentication from './components/auth/require_authentication';
import Loading from './components/common/Loading';
import withReducer from './containers/withReducer';
// Store
import initializeStore from './store'
// Actions
import { AUTH_USER, SHOW_NOTIFY, ADD_NOTIFICATION, ADD_COMMENT } from './actions'
// Admin reducer
import admin from './reducers/admin_reducer'
import client from './reducers/client_reducer'
//Notifications
import NotificationSystem from 'react-notification-system'



const store = initializeStore();
if (localStorage.getItem('token')) {
    store.dispatch({type: AUTH_USER});
    const token = localStorage.getItem('token');
    const userId = jwt_decode(token).sub;
    if(!window.Echo){
        window.Echo = new Echo({
            broadcaster: 'socket.io',
            host: window.location.hostname + ':6001',
            auth: {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        });
    }
    window.Echo.private('App.User.' + userId)
        .notification((e) => {
            console.log(e);
            if(e){
                store.dispatch({
                    type: SHOW_NOTIFY,
                    payload: {
                        message: e
                    }
                })
                store.dispatch({
                    type: SHOW_NOTIFY,
                    payload: {
                        message: {}
                    }
                })
                store.dispatch({
                    type: ADD_NOTIFICATION,
                    payload: e
                })
                if(e.comment && window.location.pathname === "/casos/" + e.comment.caso_id){
                    store.dispatch({
                        type: ADD_COMMENT,
                        payload: e.comment
                    })
                }
            };
        });
}
ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <Switch>
                <Route path="/admin/dashboard" component={RequireAuthentication(IndexAdmin)} exact />
                <Route path="/admin/clients" component={withReducer('clients', admin)(RequireAuthentication(Clients))} exact />
                <Route path="/admin/clients/new" component={withReducer('client', client)(RequireAuthentication(Loading(newClient)))}/>
                <Route path="/admin/clients/:id" component={withReducer('client', client)(RequireAuthentication(Loading(Client)))}/>
                <Route path="/admin/casos/new/:id" component={withReducer('client', client)(RequireAuthentication(Loading(CasoForm)))} exact/>

                <Route path="/login" component={Signin} exact />
                <Route path="/register" component={Signup} exact />
                <Route path="/recover" component={Recover} exact />
                <Route path="/settings" component={Loading(RequireAuthentication(Settings))} exact />
                <Route path="/casos/new" component={Loading(RequireAuthentication(CasoForm))} exact/>
                <Route path="/casos/addobj" component={Loading(RequireAuthentication(ModelosForm))} exact/>
                <Route path="/casos" component={Loading(RequireAuthentication(Casos))} exact/>
                <Route path="/casos/:id" component={Loading(RequireAuthentication(Viewer))}/>
                <Route path="/dashboard" component={RequireAuthentication(Index)} exact/>
                <Route path="/" component={RequireAuthentication(Index)} exact/>
                <Route path="*" component={NotFound} status={404}/>
            </Switch>
        </Router>
    </Provider>
    , document.getElementById('app'));


// WEBPACK FOOTER //
// ./resources/assets/js/app.js